import { Component, OnInit, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'tp-modal-template',
  templateUrl: './modal-template.component.html',
  styleUrls: ['./modal-template.component.scss']
})
export class ModalTemplateComponent implements OnInit {
  @Input() header: string;
  @Input() showCloseIcon = true;

  constructor(public dialogRef: MatDialogRef<any>) {}

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }
}
